export default __webpack_public_path__ + "static/media/sideLogo.3e5ba921.png";